module.exports = __webpack_public_path__ + "static/media/background04.71d63edb.jpg";